/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const jiraProjectComponentSchema = z.object({
  description: z.string().nullish(),
  id: z.string(),
  name: z.string(),
});
